<template>
  <b-form-checkbox-group
    :checked="value"
    :options="bladen"
    stacked 
    @input="changeBladen"
  />
</template>
<script>
import { pdfBladenMixin } from '@/mixins/pdfBladenMixin';

export default {
    name:"PdfSheets",
    mixins: [ pdfBladenMixin ],
    props: {
        value: {
            type: Array,
            required:true
        }
    },
    methods: {
        changeBladen(value) {
            //console.dir(value);
            this.$emit('input',value);
        }
     },
}
</script>